import Plus from "./plus";

const FieldGroup = ({ fonts }) => {
  return (
    <div style={{ fontFamily: `${fonts}` }}>
      <div className="mb-10">
        <h1 className="text-grey-400 mb-4">
          Page title field<span className="text-red">*</span>
        </h1>
        <span className="help-text">This is help text for this field.</span>
      </div>

      <span className="label-1 block mb-5">Standalone field</span>
      <fieldset className="flex flex-col mb-5">
        <label className="label-3 mb-2" htmlFor="#name">
          Example of label <span className="text-red">*</span>
        </label>
        <input className="form-input" id="name" type="text" />
        <span className="help-text">This is an example of help text</span>
      </fieldset>

      <button className="focus-ring">
        <div className="btn-with-icon">
          <span className="btn-with-icon__icon">
            <Plus />
          </span>
          <span className="btn-with-icon__text">Add a page</span>
        </div>
      </button>

      <div className="mt-5">
        <h2> I am some emoji's </h2>
        <p>❤️🙂🍟🍔🍜🍺😇👋🍍🦄🍎💜⏳👍🤓🐶🌍👀👽⚽️</p>
      </div>
    </div>
  );
};

export default FieldGroup;
